"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAddToCartTrackProps = getAddToCartTrackProps;
var _sharedFunctions = require("./sharedFunctions");
function getCurrentPrice({
  domain,
  isDbs,
  dbsPrice,
  isBundle,
  bundlePrices
}) {
  if (isBundle) {
    return bundlePrices?.CurrentPrice;
  }
  if (isDbs) {
    return dbsPrice;
  }
  return (0, _sharedFunctions.renderAsPremium)(domain) && domain?.Price ? domain?.Price : domain?.priceInfo?.CurrentPrice;
}
function getListPrice({
  domain,
  isDbs,
  isBundle,
  bundlePrices
}) {
  if (isBundle) {
    return bundlePrices?.ListPrice;
  }
  if (isDbs) {
    return;
  }
  return domain?.priceInfo?.ListPrice;
}
function getRenewalPrice({
  domain,
  isDbs
}) {
  if (isDbs) {
    return;
  }
  return domain?.priceInfo?.RenewalPrice;
}
function getAddToCartTrackProps({
  domains,
  type,
  tokens,
  currency,
  isReseller,
  dbsPrice,
  bundleDomains,
  bundlePrices
} = {}) {
  const result = [];
  // eslint-disable-next-line complexity
  domains.forEach(domain => {
    const isDbs = domain?.IsDbsAvailable && !isReseller;
    const isBundle = type === 'bundle';
    const isAd = domain?.IsAd;
    const isKevelAd = domain?.IsKevelAd;
    const inventory = domain?.AvailabilityLabel || domain?.Inventory;
    const currentPrice = getCurrentPrice({
      domain,
      isDbs,
      dbsPrice,
      isBundle,
      bundlePrices
    });
    const listPrice = getListPrice({
      domain,
      isDbs,
      isBundle,
      bundlePrices
    });
    const renewalPrice = getRenewalPrice({
      domain,
      isDbs
    });
    const guid = domain?.DomainGUID;
    const params = {
      ...(isBundle && {
        bundle_guid: guid
      }),
      ...(!isBundle && {
        domain_guid: guid
      }),
      ...(tokens && {
        tokens: tokens?.join(' ')
      }),
      ...(currency && {
        currency
      }),
      ...(isAd && {
        isAd
      }),
      ...(isKevelAd && {
        isKevelAd
      }),
      ...(inventory && {
        inventory
      }),
      ...(isDbs && {
        isDbs
      }),
      ...(currentPrice && {
        currentPrice
      }),
      ...(listPrice && {
        listPrice
      }),
      ...(renewalPrice && {
        renewalPrice
      }),
      fqdn: isBundle ? bundleDomains?.join(',') : domain?.Fqdn
    };
    result.push(params);
  });
  return result;
}